import { render, staticRenderFns } from "./radarBed.vue?vue&type=template&id=464f9da4&scoped=true"
import script from "./radarBed.vue?vue&type=script&lang=js"
export * from "./radarBed.vue?vue&type=script&lang=js"
import style0 from "./radarBed.vue?vue&type=style&index=0&id=464f9da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f9da4",
  null
  
)

export default component.exports